function usePageTitle(pageTitle) {
    window.document.title = `RACKEMM ${pageTitle}`
}

export default usePageTitle
